module.exports = __webpack_public_path__ + "img/love-down.52eee40b.png";